const loadItems = (button) => {
	const totalPages = parseInt($("[data-total-pages]").val());
	let currentPage = parseInt($("[data-current-page]").val());
	let nextPage = currentPage + 1;
	if (button.dataset.loading === "true") return; // prevent double triggers
	button.dataset.loading = "true";

	const nextUrl = $("[data-next-url]")
		.val()
		.replace(/page=[0-9]+/, "page=" + nextPage);
	const nextUrlScroll = $("[data-next-url]")
		.val()
		.replace(/page=[0-9]+/, "page=" + (nextPage + 1));
	$("[data-current-page]").val(nextPage);

	button.setAttribute("disabled", "");
	button.classList.add("loading");

	$.ajax({
		url: nextUrl,
		type: "GET",
		dataType: "html",
		success: function (responseHTML) {
			const newContent = $(responseHTML).find(".load-more-grid").html();
			if (newContent && newContent.trim().length > 0) {
				$(".load-more-grid").append(newContent);
				colorSwatches();
			}

			// Update infinite scroll data attributes
			const scrollData = document.querySelector(".infinite-scroll__data");
			if (scrollData && nextPage <= totalPages) {
				scrollData.querySelector("input[data-next-url]").dataset.nextUrl = nextUrlScroll;
				scrollData.querySelector("input[data-next-url]").value = nextUrlScroll;
				scrollData.querySelector("input[data-current-page]").dataset.currentPage = nextPage;
				scrollData.querySelector("input[data-current-page]").value = nextPage;
			}

			// Recheck after appending new content
			checkVisibility();
		},
		complete: function () {
			button.removeAttribute("disabled");
			button.classList.remove("loading");
			button.dataset.loading = "false";

			if (nextPage >= totalPages) {
				button.remove();
			}
		},
		error: function (xhr, status, error) {
			console.error("Load more error:", error);
			button.dataset.loading = "false";
			button.removeAttribute("disabled");
			button.classList.remove("loading");
		},
	});
};

const checkVisibility = () => {
	const spinnerList = document.querySelectorAll(".js-infinite-scroll");

	spinnerList.forEach((spinner) => {
		// Disconnect previous observers to avoid duplicates
		if (spinner._observer) {
			spinner._observer.disconnect();
		}

		const observer = new IntersectionObserver(
			(entries, obs) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						obs.unobserve(entry.target); // stop observing once triggered
						loadItems(spinner);
					}
				});
			},
			{
				root: null, // viewport
				rootMargin: "200px 0px", // preload slightly before visible
				threshold: 0.1, // trigger when 10% visible
			}
		);

		observer.observe(spinner);
		spinner._observer = observer;
	});
};

function loadMore() {
	document.querySelectorAll(".js-load-more").forEach((button) => {
		button.onclick = () => {
			loadItems(button);
		};
	});

	checkVisibility();

	// Fallback for Safari quirks (older iOS)
	window.addEventListener(
		"scroll",
		() => {
			document.querySelectorAll(".js-infinite-scroll").forEach((spinner) => {
				const rect = spinner.getBoundingClientRect();
				if (rect.top < window.innerHeight + 200 && rect.bottom > 0) {
					loadItems(spinner);
				}
			});
		},
		{ passive: true }
	);
}

(function () {
	loadMore();
})();
